// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"77f06c5b","455":"6d381e85","977":"a4d3b801"}[chunkId] + ".chunk.js";
};